"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useBasepath;
function useBasepath() {
  return process.env.REACT_STATIC_DISABLE_ROUTE_PREFIXING === 'true' ? '' : process.env.REACT_STATIC_BASE_PATH;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9icm93c2VyL2hvb2tzL3VzZUJhc2VwYXRoLmpzIl0sIm5hbWVzIjpbInVzZUJhc2VwYXRoIiwicHJvY2VzcyIsImVudiIsIlJFQUNUX1NUQVRJQ19ESVNBQkxFX1JPVVRFX1BSRUZJWElORyIsIlJFQUNUX1NUQVRJQ19CQVNFX1BBVEgiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSxXQUFULEdBQXVCO0FBQ3BDLFNBQU9DLE9BQU8sQ0FBQ0MsR0FBUixDQUFZQyxvQ0FBWixLQUFxRCxNQUFyRCxHQUNILEVBREcsR0FFSEYsT0FBTyxDQUFDQyxHQUFSLENBQVlFLHNCQUZoQjtBQUdEIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQmFzZXBhdGgoKSB7XG4gIHJldHVybiBwcm9jZXNzLmVudi5SRUFDVF9TVEFUSUNfRElTQUJMRV9ST1VURV9QUkVGSVhJTkcgPT09ICd0cnVlJ1xuICAgID8gJydcbiAgICA6IHByb2Nlc3MuZW52LlJFQUNUX1NUQVRJQ19CQVNFX1BBVEhcbn1cbiJdfQ==
void function register() {
  /* react-hot-loader/webpack */var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;
  if (!reactHotLoader) {
    return;
  } /* eslint-disable camelcase, no-undef */
  var webpackExports = typeof __webpack_exports__ !== 'undefined' ? __webpack_exports__ : exports; /* eslint-enable camelcase, no-undef */
  if (!webpackExports) {
    return;
  }
  if (typeof webpackExports === 'function') {
    reactHotLoader.register(webpackExports, 'module.exports', "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/hooks/useBasepath.js");
    return;
  } /* eslint-disable no-restricted-syntax */
  for (var key in webpackExports) {
    /* eslint-enable no-restricted-syntax */if (!Object.prototype.hasOwnProperty.call(webpackExports, key)) {
      continue;
    }
    var namedExport = void 0;
    try {
      namedExport = webpackExports[key];
    } catch (err) {
      continue;
    }
    reactHotLoader.register(namedExport, key, "/home/runner/work/shoutout_site/shoutout_site/node_modules/react-static/lib/browser/hooks/useBasepath.js");
  }
}();